<div class="row">
    <div class="col-md-12">
  <div class="input-group">
    <input [ngClass]="ngControl?.valid ? 'ng-valid' : 'ng-invalid'"
           class="form-control"
           (blur)="inputBlur($event)"
           [ngModel]="dateString | date:inputDatetimeFormat"
           (change)="onInputChange($event)"
           [disabled]="true"/>
    <div class="input-group-prepend" [ngbPopover]="calendarContent">
      <div class="input-group-text" disabled="disabled"><i class="fa fa-calendar"></i></div>
    </div>
  </div>
</div>
</div>


<ng-template #calendarContent>
  <div>
    <div *ngIf="!showTimePickerToggle">
      <ngb-datepicker id="dp" #dp name="datepicker" [ngModel]="datetime"
                      [markDisabled]="validatedDateTo"
                      (ngModelChange)="onDateChange($event, dp)"></ngb-datepicker>
      <button
        class="btn btn-block btn-outline-secondary"
        [disabled]="!datetime?.day"
        type="button"
        (click)="toggleDateTimeState($event)">
        <i class="fa fa-clock"></i>
      </button>
    </div>
    <div *ngIf="showTimePickerToggle">
      <button
        class="btn btn-block btn-outline-secondary"
        [ngbPopover]="calendarContent"
        type="button"
        (click)="toggleDateTimeState($event)"
      >
        <i class="fa fa-calendar"></i>
      </button>
      <div class="mt-auto">
        <ngb-timepicker #tp name="timepicker" [ngModel]="datetime" (ngModelChange)="onTimeChange($event)"
                        [seconds]="seconds" [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep">
        </ngb-timepicker>
      </div>
    </div>
  </div>
</ng-template>
